import { render, staticRenderFns } from "./order.vue?vue&type=template&id=44ed085a&scoped=true"
import script from "./order.js?vue&type=script&lang=js&external"
export * from "./order.js?vue&type=script&lang=js&external"
import style0 from "./order.vue?vue&type=style&index=0&id=44ed085a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ed085a",
  null
  
)

export default component.exports